import React, { useState } from 'react';

import {
  Dialog,
  DialogBody,
  DialogTitle,
} from '@/components/ui/catalyst/dialog';
import type { BrowserWorkflowOutput } from '@/types/browserAutomation';

import { RunDetail } from './RunDetail';
import { RunList } from './RunList';

interface BrowserRun {
  id: string;
  police_report_id: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'failed' | 'cancelled';
  portal_vendor: string | null;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
  found_report: boolean;
  report_ready: boolean;
  report_url: string | null;
  error_message: string | null;
  workflow_id: string | null;
  request_payload: Record<string, unknown> | null;
  result_data: BrowserWorkflowOutput | Record<string, unknown>;
}

interface BrowserRunInspectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  runs: BrowserRun[];
  departmentName: string;
}

export const BrowserRunInspectorModal = ({
  isOpen,
  onClose,
  runs,
  departmentName,
}: BrowserRunInspectorModalProps) => {
  const [selectedRunId, setSelectedRunId] = useState<string | null>(
    runs.length > 0 ? runs[0].id : null,
  );

  const selectedRun = runs.find((r) => r.id === selectedRunId);

  return (
    <Dialog open={isOpen} onClose={onClose} size="5xl">
      <DialogTitle>Browser Automation - {departmentName}</DialogTitle>
      <DialogBody className="p-0">
        {runs.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <div className="text-lg mb-2">No automation runs found</div>
            <div className="text-sm">
              Fire an ad-hoc run to see browser automation in action
            </div>
          </div>
        ) : (
          <div className="flex h-[80vh]">
            <RunList
              runs={runs}
              selectedRunId={selectedRunId}
              onSelectRun={setSelectedRunId}
            />
            {selectedRun && <RunDetail run={selectedRun} />}
          </div>
        )}
      </DialogBody>
    </Dialog>
  );
};
